var map = {
	"./pay-link/widget": [
		7524,
		363,
		332,
		133,
		856,
		250,
		11,
		323,
		513,
		524
	],
	"./payment-single/widget": [
		3876,
		363,
		332,
		133,
		856,
		250,
		11,
		323,
		513,
		876
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 46;
module.exports = webpackAsyncContext;